<template>
  <v-container fluid>
    <loader :show="$anyLoading()" :message="messageLoader"></loader>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <h4 class="green--text headline">Nuevo Usuario</h4>
      </v-flex>
      <v-flex xs12 md10 offset-md1>
        <v-card light>
          <v-card-text>
            <v-form ref="form">
              <v-container fluid grid-list-xs>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-text-field
                      name="name"
                      label="Nombre"
                      prepend-icon="person"
                      light
                      v-model="currentUser.name"
                      color="green"
                      required
                      :rules="rules.required"
                      ref="name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      name="lastname"
                      label="Apellido"
                      light
                      v-model="currentUser.lastname"
                      color="green"
                      required
                      :rules="rules.required"
                      ref="lastname"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md-6>
                    <v-text-field
                      name="phone"
                      label="Telefono"
                      light
                      v-model="currentUser.phone"
                      prepend-icon="phone"
                      color="green"
                      required
                      :rules="rules.required"
                      ref="phone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md-6>
                    <v-text-field
                      name="email"
                      label="Correo"
                      light
                      v-model="currentUser.email"
                      prepend-icon="email"
                      color="green"
                      required
                      :rules="rules.required"
                      ref="email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md-6>
                    <v-text-field
                      name="re-password"
                      type="password"
                      label="Contraseña"
                      light
                      v-model="currentUser.password"
                      prepend-icon="lock"
                      :type="seePwd ? 'text' : 'password'"
                      :append-icon="seePwd ? 'visibility' : 'visibility_off'"
                      :append-icon-cb="() => (seePwd = !seePwd)"
                      color="green"
                      required
                      :rules="rules.required"
                      ref="password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md-6>
                    <v-text-field
                      name="email"
                      label="Confirma tu Contraseña"
                      light
                      v-model="currentUser.confirmPassword"
                      color="green"
                      prepend-icon="lock"
                      :type="seeRePwd ? 'text' : 'password'"
                      :append-icon="seeRePwd ? 'visibility' : 'visibility_off'"
                      :append-icon-cb="() => (seeRePwd = !seeRePwd)"
                      :rules="rules.matchPasswords"
                      ref="confirmPassword"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-layout class="text-xs-right">
              <v-spacer></v-spacer>
              <v-btn @click="goBack" flat color="red">Cancelar</v-btn>
              <v-btn @click="save" color="green">Guardar</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import User from '@/models/user'

export default {
  name: "UserForm",
  props: ['userID'],
  data() {
    return {
      hasErrors: false,
      messageLoader: 'Cargando usuario...',
      seePwd: false,
      seeRePwd: false,
      editMode: false,
      rules: {
          required: [
              val => {
                let res = (String(val) || '').length > 0 || 'Este campo es obligatorio'
                return res
              }
          ],
          matchPasswords: [
              val => {
                let res = true

                if(this.currentUser) 
                  res = (this.currentUser.password != '' || this.currentUser.password != null)
                        && this.currentUser.password != val ? 'Las contraseñas deben coincidir' : true

                return res
              }
          ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading',
    ]),
    form() {
      return {
          name: this.currentUser.name,
          lastname: this.currentUser.lastname,
          phone: this.currentUser.phone,
          email: this.currentUser.email,
          confirmPassword: this.currentUser.confirmPassword,
      }
    }
  },
  created() {
    //do something after creating vue instance
    if(this.userID) {
      this.editMode = true
      this.loadUser(this.userID)
    }
  },
  methods: {
    ...mapActions([
      'loadUser',
      'createUser',
      'updateUser',
      'goBack'
    ]),
    save() {
      this.hasErrors = false

      Object.keys(this.form).forEach(f => {
        if(this.form[f] === null || this.form[f] === "" 
            || (f === 'confirmPassword' && this.form[f] != this.currentUser.password)) {
              this.hasErrors = true
        }

        this.$refs[f].validate(true)
      })

      if(this.hasErrors) return

      if (this.editMode) {
        this.messageLoader = 'Guardando cambios...'
        this.updateUser(this.currentUser)
      } else {
        this.messageLoader = 'Guardando...'
        this.createUser(this.currentUser)
      }
    }
  }
}
</script>
<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/users/userForm.vue